import { render } from "./FileUploadElement.vue?vue&type=template&id=6fb0d947&scoped=true"
import script from "./FileUploadElement.vue?vue&type=script&lang=js"
export * from "./FileUploadElement.vue?vue&type=script&lang=js"

import "./FileUploadElement.vue?vue&type=style&index=0&id=6fb0d947&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb0d947"]])

export default __exports__